var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { CircularProgress, Box, Button, useMediaQuery } from '@mui/material';
import { Document, Page, pdfjs } from 'react-pdf';
import theme from '../../theme';
pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdfjs.version, "/pdf.worker.min.js");
var PDFDocument = function (props) {
    var _a = useState(0), numPages = _a[0], setNumPages = _a[1];
    var _b = useState(1), pageNumber = _b[0], setPageNumber = _b[1];
    var _c = useState(), document = _c[0], setDocument = _c[1];
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    var _d = useState(720), docWidth = _d[0], setDocWidth = _d[1];
    var containerRef = useRef(null);
    useEffect(function () {
        function fetchData() {
            return __awaiter(this, void 0, void 0, function () {
                var response, blob;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, fetch(props.url)];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, response.blob()];
                        case 2:
                            blob = _a.sent();
                            setDocument(blob);
                            return [2 /*return*/];
                    }
                });
            });
        }
        fetchData();
    }, []);
    useEffect(function () {
        if (isMobile && containerRef.current) {
            setDocWidth(Math.min(containerRef.current.offsetWidth, 720));
        }
    }, [containerRef.current, isMobile]);
    return (_jsx("div", __assign({ ref: containerRef }, { children: document ? _jsxs(_Fragment, { children: [_jsx(Document, __assign({ file: document, onLoadSuccess: function (_a) {
                        var numPages = _a.numPages;
                        return setNumPages(numPages);
                    } }, { children: _jsx(Page, { width: docWidth, pageNumber: pageNumber, renderAnnotationLayer: false, renderTextLayer: false }) })), _jsx(Box, __assign({ mt: 2 }, { children: numPages && numPages > 1 ?
                        _jsxs(_Fragment, { children: [_jsxs("p", { children: ["Page ", pageNumber, " of ", numPages] }), _jsxs("div", { children: [_jsxs(Button, __assign({ size: "small", onClick: function () { return pageNumber > 1 && setPageNumber(pageNumber - 1); } }, { children: [_jsx("img", { width: "10px", height: "10px", src: "/assets/svg/pointer_blue_reverse.svg" }), "Previous"] })), _jsxs(Button, __assign({ size: "small", onClick: function () { return pageNumber < numPages && setPageNumber(pageNumber + 1); } }, { children: ["Next", _jsx("img", { width: "10px", height: "10px", src: "/assets/svg/pointer_blue.svg" })] }))] })] })
                        :
                            _jsx("p", { children: "Page 1 of 1" }) }))] }) :
            _jsx(Box, __assign({ sx: { display: 'flex', justifyContent: 'center' } }, { children: _jsx(CircularProgress, {}) })) })));
};
export default PDFDocument;
